import User from '@/domain/models/entities/user';
import facade from '@/domain/models/utils/facade';

const updateUserRaw = (state, action) => {
  state.user = facade.create(User, action.payload);
};

export * as asyncActions from './async/user';
export const actions = { updateUserRaw };
